export const DOMAIN_NAME = "config/";

export const FETCH_RESERVATION_CONFIG_SUCCESS = DOMAIN_NAME + "getReservationConfig";
export const SET_OPEN_FACILITY_SELECT = "setOpenFacilitySelect";